import React from 'react';

// Symbol + wordmark. `tone="light"` is for dark backgrounds.
export function BrandMark({ tone = 'dark', size = 'md', className = '' }) {
  const dark = tone === 'dark';
  const symbol = size === 'lg' ? 'h-14 w-14' : 'h-10 w-10';
  const word = size === 'lg' ? 'text-3xl' : 'text-xl';
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img src="/brand/symbol.webp" alt="" className={`${symbol} object-contain`} width="40" height="40" />
      <span className="flex flex-col leading-none">
        <span className={`font-display font-medium tracking-[0.2em] ${word} ${dark ? 'text-[#0A0A0A]' : 'text-[#F8F6F0]'}`}>
          VALHALLA
        </span>
        <span className={`mt-1.5 font-landing text-[0.58rem] tracking-[0.5em] ${dark ? 'text-[#8A6A12]' : 'text-[#D4AF37]'}`}>
          CORPORATIONS
        </span>
      </span>
    </span>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, tone = 'dark', align = 'left' }) {
  const dark = tone === 'dark';
  return (
    <div className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-reveal>
      <p className={`font-landing text-xs font-semibold uppercase tracking-[0.3em] ${dark ? 'text-[#8A6A12]' : 'text-[#D4AF37]'}`}>
        <span className={`mr-3 inline-block h-px w-8 align-middle ${dark ? 'bg-[#8A6A12]' : 'bg-[#D4AF37]'}`} />
        {eyebrow}
      </p>
      <h2 className={`mt-4 font-display text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl ${dark ? 'text-[#0A0A0A]' : 'text-[#F8F6F0]'}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 font-landing text-base leading-relaxed sm:text-lg ${dark ? 'text-[#4A4740]' : 'text-[#CFC8BE]'}`}>{subtitle}</p>
      )}
    </div>
  );
}
